
export const branding = {
    name: "Believe Specialist Finance Ltd",
    shortName: "Believe Specialist Finance",
    website: {
        url: "https://www.believespecialistfinance.co.uk",
        shortUrl: "believespecialistfinance.co.uk",
        description: "www.believespecialistfinance.co.uk"
    },
    phone: "01302 591 371",
    address: "Believe House, Heavens Walk, Doncaster, DN4 5HZ",
    openingHours: ["Monday - Thursday 9am - 7pm", "Friday 9am - 3pm"],
    trustPilot: {
        businessUnitId: ""
    },
    registration: {
        fca: {
            number: "973833",
            url: "https://register.fca.org.uk/s/firm?id=0014G00002wFXZ1QAO"
        },
        company: {
            number: "13913115",
            url: "https://beta.companieshouse.gov.uk/company/13913115"
        },
        dataprotection: {
            number: "ZB300048",
            url: "https://ico.org.uk/ESDWebPages/Entry/ZB300048"
        }
    },
    groupName: "Believe Money Group",
    group: "Believe Specialist Finance, Believe Loans, Believe Protect and Simply Money part of the Believe Money Group",
    appointed: {
        name: "Believe Advisor Limited",
        address: "Believe House, Heavens Walk, Doncaster, DN4 5HZ",
        phone: "01302 591 371",
        compliance: {
            email: "compliance@believeadvisor.com",
            phone: "01302 591 293"
        },
        registration: {
            fca: {
                number: "841395",
                url: "https://register.fca.org.uk/s/firm?id=0010X00004T6W1yQAF"
            },
            company: {
                number: "11842506",
                url: "https://beta.companieshouse.gov.uk/company/11842506"
            }
        }
    }
}
